import React from "react";

import { Spacer } from "shared/layout";
import { Icon, MutedText } from "shared/styles";
import { space } from "shared/styles/constants";
import { IAction } from "shared/types";
import { ActionContainer, ActionContainerProps } from "./styles";

interface ActionProps extends IAction, ActionContainerProps {
  dataTestId?: string;
  iconSize?: keyof typeof space;
  disabled?: boolean;
  viewLabel?: string;
  showViewLabel?: boolean;
  tabIndex?: number;
}

export const Action = React.forwardRef<HTMLButtonElement, ActionProps>(
  (
    {
      icon,
      iconComponent,
      actionIcon,
      label,
      viewLabel,
      subLabel,
      handleClick,
      size = "s",
      dataTestId,
      iconSize,
      tabIndex,
      showViewLabel,
      isActive,
      ...props
    },
    ref
  ) => {
    return (
      <ActionContainer
        ref={ref}
        type="button"
        size={size}
        data-testid={dataTestId}
        tabIndex={tabIndex}
        isActive={isActive}
        {...props}
      >
        <Spacer
          size="xs"
          spaceDirection="horizontal"
          flexWrap="nowrap"
          onClick={handleClick}
          justifyContent="center"
          align="center"
        >
          {icon && !iconComponent && <Icon as={icon} size={iconSize} />}
          {iconComponent}
          <Spacer size="xxs" spaceDirection="horizontal">
            <span>{showViewLabel ? viewLabel : label}</span>
            {subLabel && (
              <>
                <MutedText>•</MutedText>
                <MutedText>{subLabel}</MutedText>
              </>
            )}
          </Spacer>
          {actionIcon && <Icon size="s" as={actionIcon} />}
        </Spacer>
      </ActionContainer>
    );
  }
);
